
import CapiMachineRoot from '@shell/models/base-cluster.x-k8s.io';

export default class CapiMachineSet extends CapiMachineRoot {
}
